import { Inject, Injectable } from '@angular/core';
import { SentryService } from '@rd-lib/sentry/sentry.service';
import { PaymentGatewayService } from '@rd/core/services/payment-gateway/payment-gateway.service';
import { STRIPE_API_KEY } from '@rd/core/tokens/rd-lib.token';

@Injectable({
  providedIn: 'root',
})
export class WestpacPaymentGatewayService extends PaymentGatewayService {
  isEnable = true;

  constructor(
    protected sentryService: SentryService,
    @Inject(STRIPE_API_KEY) protected stripeApiKey: string,
  ) {
    super(sentryService, stripeApiKey);
  }
}
